import ExportVideoProgressBar from './ExportVideoProgressBar';

import styles from './ExportVideo.module.css';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import React from 'react';
import { Button, Flex } from 'antd';

const ExportVideoProgress = ({ exportState }) => {
  const showProgress =
    exportState.progress !== null &&
    true &&
    (!exportState.error || !exportState.downloadLink);

  const isFinished = exportState.status === 'finished';
  const isError = exportState.error;

  let statusToShow;
  let iconToShow;
  let title: JSX.Element | string = <span>Exporting Video</span>;
  if (isError) {
    iconToShow = <CloseCircleOutlined className={styles.exportVideoError} />;
    statusToShow = (
      <span className={styles.exportVideoProgressError}>
        <span>
          Something went wrong exporting this giide. Please try again later.
        </span>
      </span>
    );
  } else if (isFinished && exportState.downloadLink) {
    iconToShow = <CheckCircleOutlined className={styles.exportVideoOk} />;
    title = <span>Export Complete</span>;
    statusToShow = (
      <Flex vertical={true} gap={'small'}>
        <span>Your video is ready. Tap the button below to download.</span>
        <Button type={'primary'} href={exportState.downloadLink}>
          Download Video
        </Button>
      </Flex>
    );
  } else if (isFinished && !exportState.downloadLink) {
    statusToShow = (
      <span className={styles.exportCompleteStatus}>
        <LoadingOutlined spin />{' '}
        <span style={{ marginLeft: '.25rem' }}>
          Preparing your download link
        </span>
      </span>
    );
  } else {
    iconToShow = <LoadingOutlined spin className={styles.exportVideoOk} />;
    statusToShow = (
      <span>
        Your export is processing. This may take up to several minutes to
        complete.
      </span>
    );
  }

  return (
    <div className={styles.exportVideoProgress}>
      <div>{iconToShow}</div>
      <div className={styles.exportVideoProgressText}>
        {title}
        <div className={styles.exportVideoProgressGiide}>
          {exportState.title}
        </div>
        {showProgress && (
          <ExportVideoProgressBar progress={exportState.progress} />
        )}
        {statusToShow}
      </div>
    </div>
  );
};

export default ExportVideoProgress;
